/**
 * Plays a Lottie Animation on a target element
 *
 * ## Example
 *
 *    <div
 *      id="card-reader-animation"
 *      phx-hook="Lottie"
 *      data-path="https://lottie.host/my_animation.json" />
 */

import lottie from "lottie-web";

export const LottieAnimation = {
  mounted() {
    lottie.loadAnimation({
      container: this.el,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: this.el.dataset.path,
    });
  },
};

export default LottieAnimation;
